import React from "react";
import moment from "moment";
import { Oval } from "react-loader-spinner";

import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { DateRangePicker } from "../../../../components";
import { getProfitReport as getData } from "../../reportsSlice";
import { ProfitCard } from "../../components";

import "./ProfitReportView.scss";

export const ProfitReportView: React.FC = () => {
  const dispatch = useAppDispatch();

  const getProfitReportAPI = useAppSelector(
    (state) => state.reports.getProfitReportAPI
  );
  const profitReport = useAppSelector((state) => state.reports.profitReport);

  const [dateFrom, setDateFrom] = React.useState<moment.Moment>(moment());
  const [dateTo, setDateTo] = React.useState<moment.Moment>(moment());

  React.useEffect(() => {
    getProfitReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, dateTo]);

  const getProfitReport = () => {
    dispatch(
      getData({
        fromDate: moment(dateFrom).format("YYYY-MM-DD"),
        toDate: moment(dateTo).format("YYYY-MM-DD"),
      })
    );
  };

  return (
    <div className="profit-report-view-component">
      <div className="title-container">
        <div className="title-row">
          <div className="title-text">Profit Report</div>

          {getProfitReportAPI.loading && (
            <div style={{ marginLeft: 8 }}>
              <Oval
                color="#131313"
                height={20}
                width={20}
                secondaryColor="#0A60BB"
              />
            </div>
          )}
        </div>

        <DateRangePicker
          fromDate={dateFrom}
          setFromDate={setDateFrom}
          toDate={dateTo}
          setToDate={setDateTo}
        />
      </div>

      {profitReport && <ProfitCard report={profitReport} />}
    </div>
  );
};
